import React, { useEffect, useRef } from "react";
import { Dropdown, Row, Col } from "react-bootstrap";
import moment from "moment";
import "moment/locale/nb";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import companyIcon from "../../../img/company-thumbnail.png";
import { FadeButton } from "../../library/button";
import { useSelector, useDispatch } from "react-redux";
import emptyAnimation from "../../../resources/empty-animation.json";
import Lottie from "react-lottie-player";
import useOutsideAlerter from "../../hooks/useClickOutside";
import { requestUpdateUnseenNotifications } from "../../../redux/actions/user";
import "./style.scss";

const Index = ({
  title,
  size = "medium",
  spacing,
  toggle,
  color,
  type,
  content,
  options,
  actions,
  data = {
    userDetails: {},
    selectedDate: null,
  },
  open,
  setOpen,
}) => {
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state) => state.user.details.notifications
  );

  const rejectInvitationId = useSelector(
    (state) => state.user.rejectInvitation.id
  );
  const rejectInvitationLoading = useSelector(
    (state) => state.user.rejectInvitation.loading
  );

  const acceptInvitationId = useSelector(
    (state) => state.user.acceptInvitation.id
  );
  const acceptInvitationLoading = useSelector(
    (state) => state.user.acceptInvitation.loading
  );

  const notificationsWrapperRef = useRef(null);
  useOutsideAlerter(notificationsWrapperRef, () => setOpen(false));

  const profileWrapperRef = useRef(null);
  useOutsideAlerter(profileWrapperRef, () => setOpen(false));

  const dateRef = useRef(null);
  useOutsideAlerter(dateRef, () => setOpen(false));

  const regularRef = useRef(null);
  useOutsideAlerter(regularRef, () => setOpen(false));

  moment.locale("nb");

  //useOnClickOutside(notificationsMenuRef, open && setOpen(false))

  const handleDateClick = (e) => {
    if (actions && actions[0]) {
      actions[0](e);
      setOpen(false);
    }
  };

  const renderSelectedDate = () => {
    if (data.selectedDate) {
      const selection = { date: data.selectedDate, allDay: true };
      return [selection];
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (type === "notifications" && open) {
      if (notifications.content?.length > 0) {
        dispatch(
          requestUpdateUnseenNotifications({
            notifications: notifications.content,
          })
        );
      }
    }
  }, [type, open]);

  const renderNotification = (notification, index, arr) => {
    switch (notification.type) {
      case "invitation":
        return (
          <div
            className={`single-notification ${
              index === arr?.length - 1 ? "bottom" : ""
            }`}
          >
            <div className="inner-single-notification">
              <Row className="notification-row">
                <Col className="icon-col">
                  <img className="notification-icon" src={companyIcon} />
                </Col>
                <Col className="details-col">
                  <p className="timestamp">
                    {moment.unix(notification.timestamp).locale("nb").fromNow()}
                  </p>
                  <p
                    className={`description ${
                      notification.seen ? "seen" : "unseen"
                    }`}
                  >
                    <span className="highlighted">
                      {notification.payload.companyName}
                    </span>{" "}
                    har invitert deg til å bli en del av foretaket deres.
                  </p>
                  {notification.payload.accepted === null ? (
                    <div className="button-container">
                      <FadeButton
                        onClick={() => actions[0](notification.id)}
                        color="green"
                        size="xs"
                        title={
                          acceptInvitationLoading &&
                          acceptInvitationId === notification.id
                            ? "Laster"
                            : "Aksepter"
                        }
                      />
                      <FadeButton
                        onClick={() => actions[1](notification.id)}
                        color="red"
                        size="xs"
                        spacing="left"
                        title={
                          rejectInvitationLoading &&
                          rejectInvitationId === notification.id
                            ? "Laster"
                            : "Avslå"
                        }
                      />
                    </div>
                  ) : (
                    <p
                      className={`confirmation ${
                        notification.payload.accepted ? "accepted" : "rejected"
                      }`}
                    >
                      Du{" "}
                      {notification.payload.accepted ? "aksepterte" : "avviste"}{" "}
                      denne forespørselen.
                    </p>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  if (content === "profile") {
    return (
      <Dropdown
        drop="down"
        show={open}
        className={`filter-dropdown type-${type}`}
        autoClose="outside"
      >
        {toggle}
        <Dropdown.Menu
          ref={profileWrapperRef}
          onBlur={() => setOpen(false)}
          align="end"
          className="dropdown-selection profile"
        >
          <div className="profile-container">
            <div className="thumbnail">
              <img
                className="user-thumbnail"
                src={
                  data.userDetails && data.userDetails.thumbnail
                    ? data.userDetails.thumbnail
                    : null
                }
              />
              <span className="online-indicator" />
            </div>
            <div className="details">
              <span className="name">
                {data.userDetails && data.userDetails.name
                  ? data.userDetails.name
                  : null}
              </span>
              <span className="roles">{`Knyttet til ${
                data.userDetails && data.userDetails.roles
                  ? data.userDetails.roles
                  : 0
              } selskap${
                data.userDetails &&
                data.userDetails.roles &&
                data.userDetails.roles.length > 1
                  ? "er"
                  : ""
              }`}</span>
            </div>
          </div>
          <Dropdown.Divider />
          {options &&
            options.length > 0 &&
            options.map((selection) => {
              if (selection.key === "separator") {
                return <Dropdown.Divider />;
              } else {
                return (
                  <Dropdown.Item
                    id={selection.id}
                    onClick={selection.action}
                    className={`${selection.active ? "active" : ""}`}
                  >
                    <span className="dropdown-select">{selection.title}</span>
                  </Dropdown.Item>
                );
              }
            })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (content === "regular") {
    return (
      <Dropdown
        drop="down"
        show={open}
        className={`filter-dropdown ${color ? `color-${color}` : ""} ${
          size ? `size-${size}` : ""
        } ${spacing ? `spacing-${spacing}` : ""} type-${type} ${
          content ? `content-${content}` : ""
        }`}
        autoClose="outside"
      >
        {toggle}
        <Dropdown.Menu
          ref={regularRef}
          onBlur={() => setOpen(false)}
          align="end"
          className="dropdown-selection regular"
        >
          {title ? <h5 className="dropdown-title">{title}</h5> : null}
          {options &&
            options.length > 0 &&
            options.map((selection) => {
              if (selection.key === "separator") {
                return <Dropdown.Divider />;
              } else {
                return (
                  <Dropdown.Item
                    id={selection.id}
                    onClick={selection.action}
                    className={`${selection.active ? "active" : ""}`}
                  >
                    <span className="dropdown-select">{selection.title}</span>{" "}
                    {selection.active ? (
                      <i class="fad fa-check checked"></i>
                    ) : null}
                  </Dropdown.Item>
                );
              }
            })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (content === "notifications") {
    return (
      <Dropdown
        drop="down"
        show={open}
        className={`filter-dropdown type-${type} ${
          content ? `content-${content}` : ""
        }`}
        autoClose="outside"
      >
        {toggle}
        <Dropdown.Menu
          ref={notificationsWrapperRef}
          align="end"
          className="dropdown-selection notifications"
        >
          {title ? <h5 className="dropdown-title">{title}</h5> : null}
          <div className="all-notifications-container">
            {options &&
              options.content?.map((notification, index, arr) => {
                return renderNotification(notification, index, arr);
              })}
          </div>
          {options.size === 0 && (
            <div className="empty-notifications-container">
              <div className="animation-container">
                <Lottie
                  animationData={emptyAnimation}
                  loop
                  play
                  className="animation-player"
                />
              </div>
              <h3 className="empty-title">Ingen varlser</h3>
              <label className="empty-description">Du har ingen varsler.</label>
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (content === "date") {
    return (
      <Dropdown
        show={open}
        drop="down"
        className={`filter-dropdown ${color ? `color-${color}` : ""} ${
          size ? `size-${size}` : ""
        } ${spacing ? `spacing-${spacing}` : ""} type-${type} ${
          content ? `content-${content}` : ""
        }`}
        autoClose="outside"
      >
        {toggle}
        <Dropdown.Menu
          ref={dateRef}
          align={"right"}
          className="dropdown-selection calendar"
        >
          <FullCalendar
            dateClick={(e) => handleDateClick(e)}
            className="small-calendar-view"
            editable={true}
            defaultView="dayGridMonth"
            header={{ left: "prev", center: "title", right: "next" }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            events={renderSelectedDate()}
          />
        </Dropdown.Menu>
      </Dropdown>
    );
  }
  return null;
};

export default Index;
